import React from "react";
import Navbar from "./common/Navbar";
import SubFooter from "./common/SubFooter";
import Footer from "./common/Footer";
import ProjectList from "./ProjectList";
import { ProjectArr } from "./data/ProjectData";

const Projects = () => {
  return (
    <React.Fragment>
      <main className="flex-shrink-0">
        <Navbar />
        <section>
          <div className="container px-5">
            <div className="text-center mb-5">
              <h1 className="display-6 fw-bolder mb-0">
                <span className="text-gradient d-inline">Projects</span>
              </h1>
            </div>
            <div className="row gx-5 justify-content-center">
              <div className="col-lg-12 col-xl-12 col-xxl-10">
                {ProjectArr.map((item) => (
                  <ProjectList key={item} detail={item} />
                ))}
              </div>
            </div>
          </div>
        </section>
      </main>
      <SubFooter />
      <Footer />
    </React.Fragment>
  );
};

export default Projects;
